/**
 * Pure helpers for "Shortcuts" (saved Task Library filter views). Storage
 * itself is backend-persisted per account (queries/shortcuts.js), not
 * localStorage — this file only has the canonicalization/matching logic,
 * mirrored server-side in backend/src/routes/shortcuts/services.js so
 * "re-saving the same filter combo renames in place" works without a round
 * trip to ask the frontend what it considers equivalent.
 */
import { AXES, AXIS_QUERY_KEYS, getAxisValues } from "./onboardingAxes";

/** Only the 4 onboarding axes, sorted/deduped, so param order never breaks a match. */
export function canonicalizeAxisSearch(search) {
  const params = new URLSearchParams(search || "");
  const parts = AXES.map((axis) => {
    const values = getAxisValues(params, axis).map((v) => v.toLowerCase()).sort();
    return values.length ? `${AXIS_QUERY_KEYS[axis]}=${values.join(",")}` : null;
  }).filter(Boolean);
  return parts.sort().join("&");
}

export function findShortcutByFilters(list, search) {
  const key = canonicalizeAxisSearch(search);
  if (!key) return null;
  return (list || []).find((s) => canonicalizeAxisSearch(s.search) === key) || null;
}

// Ephemeral cross-tree signal only (never persisted/fetched): the "Show me"
// button on the saved-confirmation pop-up (rendered from ConversationWrapper)
// tells the sidebar's Shortcuts list (rendered from AppNav, a separate
// component tree under AppShell) which row to briefly highlight.
const highlightListeners = new Set();
export function requestShortcutHighlight(id) {
  highlightListeners.forEach((fn) => fn(id));
}
export function subscribeShortcutHighlight(fn) {
  highlightListeners.add(fn);
  return () => highlightListeners.delete(fn);
}
